const BASE_PATH = 'https://dev365.gdpventure.com/drupal-backend/api/connect';
export const BASE_PATH_URL = 'https://dev365.gdpventure.com';
export const API = {
	getData(url = '') {
		const URL = BASE_PATH + url;
		return fetch(URL, {
			method : 'GET'
		}).then((response) => response.json());
	},

	getFooterDetails() {
		const URL = 'https://dev365.gdpventure.com/drupal-backend/api/venture/footer';
		return fetch(URL, {
			method : 'GET'
		}).then((response) => response.json());
	},

	getrecommendationData(url = '', bodyData = {}) {
		const URL = 'https://dev365.gdpventure.com/drupal-backend/api/connect' + url;
		return fetch(URL, {
			method : 'POST',
			body   : JSON.stringify(bodyData)
		}).then((response) => response.json());
	},

	getPOSTData(url = '', bodyData = {}) {
		const URL = 'https://dev365.gdpventure.com/drupal-backend/api/' + url;
		return fetch(URL, {
			method : 'POST',
			body   : JSON.stringify(bodyData)
		}).then((response) => response.json());
	},

	getArticleByArticleURL(url = '') {
		const URL = 'https://dev365.gdpventure.com/drupal-backend/api/connect/blob' + url;
		return fetch(URL, {
			method : 'GET'
		}).then((response) => response.json());
	}
	// http://dev365.gdpventure.com/drupal-backend/api/connect/blob/Endeus-Food-Story-Competition
};



// WEBPACK FOOTER //
// ./components/API/index.js